<script>
import { DeleteOutlined, EditOutlined } from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import { mapState } from 'vuex';
import constants from '@/pages/article/articleAdsBanner/constants';

const b = bem('product-ads');

const {
  PRODUCTS_LIST,
} = constants;

export default {
  data() {
    return {
      PRODUCTS_LIST,
      productInformation: {},
      parentProductInformation: {},
      informationProductCollection: {},
    };
  },
  components: {
    DeleteOutlined,
    EditOutlined,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
    onEdit: {
      type: Function,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    getProductInformation() {
      const {
        id,
        parentId,
        productCollectionId,
      } = this.card.product;
      if (
        productCollectionId
        && this.allInfoProductCollection
        && this.allInfoProductCollection.length > 0
      ) {
        this.informationProductCollection = this.allInfoProductCollection
          .find((item) => item.id === productCollectionId) || {};
        this.parentProductInformation = this.informationProductCollection.products
          .find((item) => item.id === parentId) || {};
        this.productInformation = this.parentProductInformation.options
          .find((item) => item.id === id) || {};
        return;
      }
      if (!productCollectionId && parentId && this.productList && this.productList.length > 0) {
        this.parentProductInformation = this.productList
          .find((item) => item.id === parentId) || {};
        this.productInformation = this.parentProductInformation.options
          .find((item) => item.id === id) || {};
      }
      if (!productCollectionId && !parentId) {
        this.productInformation = this.productList.find((item) => item.id === id) || {};
      }
    },
  },
  computed: {
    ...mapState({
      productList: (state) => state.products.productList,
      allInfoProductCollection: (state) => state.products.allInfoProductCollection,
    }),
  },
  watch: {
    productList(value) {
      if (value.length) {
        this.getProductInformation();
      }
    },
    allInfoProductCollection(value) {
      if (value.length) {
        this.getProductInformation();
      }
    },
  },
};
</script>

<template>
  <div :class="b('item')">
    <div :class="b('buttons')">
      <a-button
        class="action-button"
        type="primary"
        html-type="button"
        @click="() => onEdit({
          ...card,
          informationProductCollection,
        })"
        ghost
      >
        <EditOutlined /> Edit
      </a-button>
      <a-popconfirm title="Sure to delete?" @confirm="() => onDelete(card.id)">
        <a-button
          type="primary"
          html-type="button"
          danger
          class="action-button"
          ghost
        >
          <DeleteOutlined /> Delete
        </a-button>
      </a-popconfirm>
    </div>
    <div :class="b('content')">
      <div :class="b('image-wrap')" v-if="card.imageUrl || productInformation?.imageUri">
        <img
          :class="b('image')"
          :src="card.imageUrl || productInformation?.imageUri"
          alt="custom-preview"
        />
      </div>
      <div :class="b('title')">{{ productInformation.displayName }}</div>
      <div :class="b('description')">
        from<span :class="b('price')">{{ productInformation.price }}$</span>
      </div>
    </div>
  </div>
</template>

<style src="./productAdsCartStyle.scss" lang="scss" scoped/>
